import classNames from "classnames";
import { useRef } from "react";
import { Icon, ImageLite, SwiperLayout } from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import styles from "./SliderImages.module.scss";

export const SliderImages = ({ images }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { isDesktop } = useViewMode();

  return (
    <div className={styles.slider}>
      <SwiperLayout
        prevRef={prevRef}
        nextRef={nextRef}
        watchOverflow={false}
        slidesPerView={1}
        slidesPerGroup={1}
        loop={true}
        paginationWrapper={styles.pagination}
      >
        {images.map((image) => (
          <SwiperSlide key={image.id} className={styles.slide}>
            <ImageLite image={image} className={styles.image} />
          </SwiperSlide>
        ))}
      </SwiperLayout>
      <div className={styles["navigation-wrapper"]}>
        <div className={styles["slider-navigation"]}>
          <div
            ref={prevRef}
            className={classNames(styles.navigation, styles["navigation-prev"])}
          >
            <Icon className={styles.icon} name="arrow_slider_prev" />
          </div>
          <div
            ref={nextRef}
            className={classNames(styles.navigation, styles["navigation-next"])}
          >
            <Icon className={styles.icon} name="arrow_slider_next" />
          </div>
        </div>
        {isDesktop && <div className={styles.pagination}></div>}
      </div>
    </div>
  );
};
